import smoothScroll from 'smoothscroll-polyfill';

smoothScroll.polyfill();

const scrollToView = (selector: string): void => {
  const errorMsgEl = document.querySelector(selector);
  errorMsgEl?.scrollIntoView({ behavior: 'smooth' });
};

export default scrollToView;
